var map = {
	"./boleto-barcode-dark.svg": "c5a1",
	"./boleto-barcode.svg": "a301",
	"./diners-dark.svg": "5d28",
	"./diners.svg": "3130",
	"./elo-dark.svg": "3b29",
	"./elo.svg": "e432",
	"./hipercard-v2-dark.svg": "e833",
	"./hipercard-v2.svg": "491d",
	"./mastercard-dark.svg": "2c88",
	"./mastercard.svg": "cc08",
	"./pci-dark.svg": "8112",
	"./pci.svg": "8008",
	"./visa-dark.svg": "afc4",
	"./visa.svg": "52c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c42";